<template>
  <div>
    <el-row :gutter="20">
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData[idField]"
          :base="base"
          :name="idField"
          disabled
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.number"
          :base="base"
          name="number"
          disabled
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="12">
        <std-opt
          v-model="formData.type"
          name="documentType"
          disabled
        >
        </std-opt>
      </el-col>
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.date"
          :base="base"
          name="date"
          disabled
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="12">
        <std-opt
          v-model="formData.due_date_type"
          name="documentDueDateType"
          disabled
        >
        </std-opt>
      </el-col>
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.due_date"
          :base="base"
          name="due_date"
          disabled
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="8">
        <text-field
          v-model="formData.bid"
          :base="base"
          name="bid"
          disabled
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="8">
        <text-field
          v-model="formData.branch_name"
          :base="base"
          name="branch_name"
          disabled
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="8">
        <text-field
          v-model="formData.legal_entity_name"
          :base="base"
          name="legal_entity_name"
          disabled
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.region_id"
          :base="base"
          name="region_id"
          disabled
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="12">
        <text-field
          v-model="formData.region_name"
          :base="base"
          name="region_name"
          disabled
        >
        </text-field>
      </el-col>
      <slot name="append-fields"></slot>
      <el-col
        v-show="!isReceipt"
        :xs="24" :md="12"
      >
        <std-opt
          v-model="formData.vat_apply_type"
          name="documentVATApplyType"
          disabled
        >
        </std-opt>
      </el-col>
      <el-col
        v-show="!isReceipt"
        :xs="24" :md="12"
      >
        <std-opt
          v-model="formData.vat_type"
          name="vatType"
          disabled
        >
        </std-opt>
      </el-col>
      <el-col :xs="24" :md="8">
        <text-field
          v-model.number="formData.amount"
          :base="base"
          name="amount"
          disabled
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="8">
        <text-field
          v-model.number="formData.vat_amount"
          :base="base"
          name="vat_amount"
          disabled
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="8">
        <text-field
          v-model.number="formData.total_amount"
          :base="base"
          name="total_amount"
          disabled
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="24">
        <text-field
          v-model.number="formData.balance"
          :base="base"
          name="balance"
          disabled
        >
        </text-field>
      </el-col>
    </el-row>
    <item-table
      v-show="!isReceipt"
      :base="base"
      :item="formData.item"
    >
    </item-table>
    <apply-doc-table
      v-show="isReceipt"
      :base="base"
      :applyDoc="formData.apply_doc"
    >
    </apply-doc-table>
    <attach-table
      :base="base"
      :attach="formData.attach"
    >
    </attach-table>
    <el-row :gutter="20">
      <el-col :xs="24" :md="24">
        <text-field
          v-model="formData.subject"
          :base="base"
          name="subject"
          disabled
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="24">
        <text-field
          v-model="formData.remark"
          :base="base"
          name="remark"
          disabled
        >
        </text-field>
      </el-col>
      <el-col :xs="24" :md="24">
        <text-field
          v-model="formData.memo"
          :base="base"
          name="memo"
        >
        </text-field>
      </el-col>
    </el-row>
    </div>
</template>

<script>
import ItemTable from './ItemTable'
import ApplyDocTable from './ApplyDocTable'
import AttachTable from './AttachTable'
import {
  SOADocumentType
} from '@/enums'

export default {
  name: 'base-soa-field',
  components: {
    ItemTable,
    ApplyDocTable,
    AttachTable
  },
  props: {
    base: {
      type: String,
      required: true
    },
    idField: {
      type: String,
      default: 'doc_id'
    },
    formData: {
      type: Object,
      required: true
    }
  },
  computed: {
    isReceipt () {
      return this.formData.type === SOADocumentType.Receipt
    }
  },
  data () {
    return {}
  }
}
</script>
